export default (message) => {
  window.alert(message);
};
